import {Nullable} from "../../definitions/types";
import {ItemType} from "../../definitions/enums";

export class CustomizedItemModel {
    private readonly _id?: number;
    public readonly itemType?: ItemType;
    private readonly _url?: string;
    private readonly _path?: string;

    constructor(public readonly customizedPrimary: Nullable<{
        id: number;
        itemType: ItemType;
        url: string,
        path: string
    }>) {
        this._id = customizedPrimary?.id;
        this.itemType = customizedPrimary?.itemType;
        this._url = customizedPrimary?.url;
        this._path = customizedPrimary?.path;
    }

    /**
     * @method id
     * @returns {number | undefined}
     * @description Returns the id of the customized primary image. If the id is undefined, then it returns undefined.
     * @example
     * const customizedPrimary = new CustomizedPrimaryModel({id: 1, url: "https://www.example.com/image.jpg"});
     * console.log(customizedPrimary.id); // 1
     */
    public get id(): number | undefined {
        return this._id;
    }

    /**
     * @property itemType
     * @returns {ItemType | undefined}
     * @description Returns the item type of the customized primary image. If the item type is undefined, then it returns undefined.
     */
    public get type(): ItemType | undefined {
        return this.itemType;
    }

    /**
     * @method url
     * @returns {string | undefined}
     * @description Returns the url of the customized primary image. If the url is undefined, then it returns undefined.
     * @example
     * const customizedPrimary = new CustomizedPrimaryModel({id: 1, url: "https://www.example.com/image.jpg"});
     * console.log(customizedPrimary.url); // https://www.example.com/image.jpg
     */
    public get url(): string | undefined {
        return this._url;
    }

    /**
     * @property path
     * @returns {string | undefined}
     * @description Returns the path of the customized primary image. If the path is undefined, then it returns undefined.
     */
    public get path(): string | undefined {
        return this._path;
    }
}